import React from 'react'
import { NavigationItems } from '../../NavigationItems/NavigationItems'

export const Tooltip = (props) => {
    return (
        <div className=" lg:hidden p-7 h-10">
            <nav className="flex justify-between">
            <img src="./assets/shared/logo.svg" alt="logo" />
            <img onClick={props.tooltipHandler} src="./assets/shared/icon-hamburger.svg" alt="menu" className="p-3"/>
            </nav>

            <div 
            style={{transform: props.modal ? "translateY(0)" : 'translateY(-100vh)'}}
            className="transition-all ease-out duration-700 z-50"
            >
            
            <section className={"w-full bg-white h-80 rounded-2xl mt-8 pt-1 z-50"}>
                <NavigationItems tooltipHandler={props.tooltipHandler}></NavigationItems>
                <img onClick={props.tooltipHandler} src="./assets/close.svg" alt="close" className=" w-1/12 m-auto cursor-pointer mt-6"/>
            </section>
            </div>
            
        </div>
)
}

